import { combineReducers } from 'redux';

import entitiesReducer from './entities';
import uiDealersReducer from './ui';

/**
 * @typedef {{
 *  entities: import('./entities').DealersEntitiesReducer
 *  ui: import('./ui').DealersUiReducer
 * }} DealersReducer
 */

const Combination = {
  entities: entitiesReducer,
  ui: uiDealersReducer,
};

export default combineReducers(Combination);
